export default "__VITE_PUBLIC_ASSET__a078048e__"